import { SanityContentPage } from 'src/components/layouts/Page/SanityContentPage'

const ImpactPage = () => {
  return <SanityContentPage slug='impact' />
}

export default ImpactPage
